const time = {
    "周": "неделя",
    "天": "день",
    "小时": "час",
    "分钟": "минута",
    "刚刚": "только что",
    "前": "назад",
    "昨天": "вчера",
    "星期一": "понедельник",
    "星期二": "вторник",
    "星期三": "среда",
    "星期四": "четверг",
    "星期五": "пятница",
    "星期六": "суббота",
    "星期日": "воскресенье",
    "一月": "январь",
    "二月": "февраль",
    "三月": "март",
    "四月": "апрель",
    "五月": "май",
    "六月": "июнь",
    "七月": "июль",
    "八月": "август",
    "九月": "сентябрь",
    "十月": "октябрь",
    "十一月": "ноябрь",
    "十二月": "декабрь",
}

export default time;
